import gql from 'graphql-tag'

const UNIT_FIELDS_FRAGMENT = gql`
  fragment UnitFields on Unit {
    id
    title
    description
    status
    bedrooms
    baths
    halfBaths
    sqft
    price
    ppsf
    mlsId
    customFields {
      value
      customFieldDefinition {
        id
        sequence
        availableOn
        canonicalName
        dataType
        name
      }
    }
    images {
      id
      title
      url
      sequence
    }
    floorPlan {
      id
      title
      propertyType
      bedrooms
      baths
      halfBaths
      baseSqft
      exteriorSqft
      den
      basement
      virtualTourUrl
      collection {
        id
        name
      }
      images {
        id
        sequence
        url
      }
      documents {
        id
        title
        sequence
        url
        file {
          mimeType
        }
      }
    }
  }
`

export default ($edgewise) => ({
  get: (...args) => get($edgewise, ...args),
  list: (...args) => list($edgewise, ...args)
})

async function get($edgewise, unitId) {
  try {
    const { unit } = await $edgewise.graphqlClient.request(
      gql`
        ${UNIT_FIELDS_FRAGMENT}
        query jssdk_get_unit($unitId: ID!) {
          unit(id: $unitId) {
            ...UnitFields
          }
        }
      `,
      { unitId }
    )

    return unit
  } catch (err) {
    console.error(err)
    throw err
  }
}

async function list($edgewise, input) {
  try {
    const { project } = await $edgewise.graphqlClient.request(
      gql`
        ${UNIT_FIELDS_FRAGMENT}
        query jssdk_list_units($projectId: ID!) {
          project(id: $projectId) {
            id
            units {
              ...UnitFields
            }
          }
        }
      `,
      input
    )

    return project.units
  } catch (err) {
    console.error(err)
    throw err
  }
}
